import { School } from './../../../models/school';
import { ExcelService } from './../../../services/excel.service';
import { NgxRolesService } from 'ngx-permissions';
import { AuthService } from './../../../services/auth.service';
import { Observable } from 'rxjs/Observable';
import { DataTablesResponse } from './../../../models/DataTablesResponse';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Passenger } from './../../../models/passenger';
import { Component, OnInit, OnDestroy, ViewChild, NgZone } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Select2OptionData } from 'ng2-select2';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { PNotifyService } from '../../../services/pnotify.service';

@Component({
  selector: 'app-passenger-archive',
  templateUrl: './passenger-archive.component.html',
  styleUrls: ['./passenger-archive.component.css']
})
export class PassengerArchiveComponent implements OnInit , OnDestroy {

  isActive: boolean;
  routeBase: string;

  filter = {
    clientId: '',
    schoolId: '',
    busId: '',
    journeyId: '',
    name: '',
    isAssistant: false,
    isActive: false,
    isAdmin: false
  };
  staticFilter: any;
  public clientsData: Array<Select2OptionData>;
  public schoolsData: Array<Select2OptionData>;
  public busesData: Array<Select2OptionData>;
  public journeysData: Array<Select2OptionData>;
  adminStatus = true;

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  // ----- Start Option Scrollbar -----------
  isScrollbar: true;
  scrollbarOptions = {
    axis: 'y',
    theme: 'minimal-dark'
  };
  // ----- End Option Scrollbar -----------

  selectedAll = false;
  selectedMulti = false;

  dtOptions: any = {};
  dtCurrentpage: any;
  dtCurrentLen: any;
  dtIntiFlag: any;
  clients: any[];
  schools: any[];
  buses: any[];
  passengers: any[];
  journeys: any[];
  pnotify = undefined;
  isResponsible = false;
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private roleService: NgxRolesService,
    private excelService: ExcelService,
    private router: Router,
    private route: ActivatedRoute,
    private zone: NgZone,
    pnotifyService: PNotifyService
  ) {
    this.isActive = false;
    this.routeBase = 'passenger/archive';
    this.dtIntiFlag = false;
    this.route.params.subscribe(params => {
      this.dtCurrentpage = params['PgNo'];
      this.dtCurrentLen = params['PgLen'];
    });
    this.initClientSelect();
    this.pnotify = pnotifyService.getPNotify();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
    }
  }

   ngOnInit(): void {
    /* this.route.data
      .subscribe((data: { isActive: boolean }) => {
        this.routeBase = 'passenger/archive';
        this.isActive = data.isActive;
        this.filter.isActive = data.isActive;
      }); */
      if (this.roleService.getRole('ROLE_ADMIN')) {
        this.filter.isAdmin = true; 
      }
    // Event lors de la fin d'init du dt
    $('table').on('init.dt', (event) => this.initPaginationTable());

    const columns = [
      { data: 'checkbox' },
      { data: 'busSchoolName' },
      { data: 'busName' },
      { data: 'lastname' },
      { data: 'firstnames' },
      // { data: 'count' },
      { data: 'phone' },
      { data: 'subscription' },
      { data: 'positionStatus' },
      { data: 'activationKey' },
      { data: 'SmsToSend' },
      { data: 'actions' },
    ];
    // if (this.isAssistant) {
    //   columns.splice(7, 1);
    //   columns.splice(5, 1);
    //   columns.splice(4, 1);
    // }
    if (this.roleService.getRole('ROLE_ADMIN')) {
      columns.splice(1, 0, { data: 'clientName' });
    }
    this.dtOptions = {
      searching: false,
      pageLength: Number(this.dtCurrentLen),
      serverSide: true,
      processing: true,
      lengthMenu: [[5, 10, 25, 50, 100], [5, 10, 25, 50, 100]],
      order: [[1, 'asc']],
      ordering: false,
      columnDefs: [
        { 'orderable': false, 'targets': 0 }
      ],
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.filter = this.staticFilter;
        this.http.post<DataTablesResponse>(
          // '/api/passenger/listArchive',
          '/api/passenger/',
          dataTablesParameters,
          {}
        ).subscribe((resp: any) => {
          this.passengers = resp.data;
          let dta = [];
          this.passengers.forEach((passenger, index) => {
            const btnActiverETSupprimer = `
                                          <button class="btn btnAction btnActive" data-passenger-id="${passenger.id}">
                                            <i class="fa fa-user-plus fa-2x" aria-hidden="true"></i>Activer
                                          </button>
                                          <button class="btn btnAction btnDelete" data-passenger-id="${passenger.id}">
                                            <i class="fa fa-trash fa-2x" aria-hidden="true"></i>Supprimer
                                          </button>
                                        `;
            
            
            dta.push({
              id: passenger.id,
              checkbox: `<label class="el-switch" style="font-size:80%">
                          <input  type="checkbox"
                                  name="checkboxs[]"
                                  value="${passenger.id}"
                                  ${this.selectedAll ? 'checked' : ''}
                          >
                          <span class="el-switch-style"></span>
                        </label>`,
              busSchoolName: passenger.School ? passenger.School.name : '',
              busName: passenger.Bus ? passenger.Bus.name : '',
              lastname: passenger.lastname,
              firstnames: passenger.firstnames,
              // count: passenger.count,
              phone: passenger.phone,
              subscription: passenger.subscription,
              positionStatus: (passenger.isPositionValide ? 'Définie' : 'Non définie'),
              activationKey: passenger.activationKey,
              SmsToSend: passenger.SmsToSend == 0 ? `<label style="color:green">Envoyé</label>`
              : `<label style="color:orange">En-cours</label>`,
              actions: `
                ${(this.adminStatus) ? btnActiverETSupprimer : ''}
              `
            });

            if (this.roleService.getRole('ROLE_ADMIN')) {
              dta[index].clientName = passenger.School.Client.name;
            }
          });

          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: dta
          });
        });
      },
      fnCreatedRow: function (nRow, aData, iDataIndex) {
        $(nRow).attr('id', 'passenger_' + aData.id);
      },
      columns: columns,
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        'sProcessing': 'Traitement en cours...',
        'sSearch': 'Rechercher&nbsp;:',
        'sLengthMenu': 'Afficher _MENU_ &eacute;l&eacute;ments',
        'sInfo': 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        'sInfoEmpty': 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        'sInfoFiltered': '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        'sInfoPostFix': '',
        'sLoadingRecords': 'Chargement en cours...',
        'sZeroRecords': 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        'sEmptyTable': 'Aucune donn&eacute;e disponible dans le tableau',
        'oPaginate': {
          'sFirst': 'Premier',
          'sPrevious': 'Pr&eacute;c&eacute;dent',
          'sNext': 'Suivant',
          'sLast': 'Dernier'
        },
        'oAria': {
          'sSortAscending': ': activer pour trier la colonne par ordre croissant',
          'sSortDescending': ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
      // Use this attribute to enable the responsive extension
      responsive: true
    };
    $('table').on('click', '.btnDelete', (event) => {
      this.onDelete($(event.currentTarget).data('passengerId'));
    });
    $('table').on('click', '.btnActive', (event) => {
      this.onActive($(event.currentTarget).data('passengerId'));
    });
    $('table').on('click', '.btnNavigate', (event) => {
      this.onNavigate($(event.currentTarget).data('url') + '/' + this.dtCurrentpage + '/' + this.dtCurrentLen);
    });
    $('table').on('change', '[name="checkboxs[]"]', (event) => this.onCheckChange());

    $('table').on('draw.dt', (event) => this.onDtDrawChange());

  }

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
    $('table').off();
  }

  initPaginationTable(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      const pgsInfo = dtInstance.page.info();
      const totalPg = pgsInfo.pages;
      let pgNo  = 0;

      if (this.dtCurrentpage === 'last' ) {
        pgNo = totalPg - 1;
      } else {
        pgNo = Number(this.dtCurrentpage);
      }
      // dtInstance.page.len(Number(this.dtCurrentLen));
      dtInstance.page(pgNo);
      dtInstance.draw(false);
      this.dtIntiFlag = true;
   });
  }

  updatePaginationInfo(): void {
    if (this.dtIntiFlag === true) {
      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
        const pgsInfo = dtInstance.page.info();
        this.dtCurrentpage = pgsInfo.page;
        this.dtCurrentLen = pgsInfo.length;
     });
    }
  }

  initClientSelect() {
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      const client = this.authService.getUser();
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const client = this.authService.getUser().School.Client;
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.adminStatus = this.authService.getUser().isRespAdmin;
      this.initSchoolSelect();
    } else {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
        const array1 = [{ id: '', text: 'Choisir un client' }];
        const array2 = this.clients.map(function (client, index) {
          return { id: client.id, text: client.name };
        });
        this.clientsData = array1.concat(array2);
        // this.initSchoolSelect();
      });
    }
    this.staticFilter = this.filter;
  }

  clientChanged(e: any) {
    this.filter.clientId = e.value;
    this.initSchoolSelect();
  }

  initSchoolSelect() {
    this.filter.schoolId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
      const array1 = [{ id: '', text: 'Choisir une option' }];
      const array2 = this.schools.map((school, index) => {
        if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
          return {
            id: school.id,
            text: school.name,
            selected: (this.authService.getUser().School.id === school.id) ? true : false
          };
        } else {
          return { id: school.id, text: school.name };
        }
      });
      this.schoolsData = array1.concat(array2);
      this.busesData = [{ id: '', text: 'Choisir une option' }];
      // this.initBusSelect();
    });
  }
  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    this.initBusSelect();
  }

  initBusSelect() {
    this.filter.busId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
      const array1 = [{ id: '', text: 'Choisir une option' }];
      const array2 = this.buses.map(function (bus, index) {
        return { id: bus.id, text: bus.name };
      });
      this.busesData = array1.concat(array2);
    });
  }

  busChanged(e: any) {
    this.filter.busId = e.value;
    this.initJourneySelect();
  }

  initJourneySelect() {
    this.filter.journeyId = '';
    const params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId,
        busId: this.filter.busId
      }
    });
    this.http.get(
      '/api/journey/lookup',
      { params }
    ).subscribe((journeys: any[]) => {
      this.journeys = journeys;
      const array1 = [{ id: '', text: 'Choisir une trajet' }];
      const array2 = this.journeys.map(function (journey, index) {
        return { id: journey.id, text: journey.name };
      });
      this.journeysData = array1.concat(array2);
    });
  }

  journeyChanged(e: any) {
    this.filter.journeyId = e.value;
  }

  onSelectedAllChange() {
    $('[name="checkboxs[]"]').prop('checked', this.selectedAll);
    this.onCheckChange();
  }

  onCheckChange() {
    const length = $('[name="checkboxs[]"]:checked').length;
    if (length > 1) {
      this.selectedMulti = true;
    } else {
      this.selectedMulti = false;
    }
  }

  onDtDrawChange() {
    this.onCheckChange();
    this.updatePaginationInfo();
  }

  onNavigate(url) {
    this.zone.run(() => this.router.navigateByUrl(url));
  }

  onDelete(id) {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer cet element ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.delete(id);
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  onActive(id) {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous activer cet element ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.active(id);
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  active(id) {
    let selectedpassenger;
    this.passengers.forEach((passenger) => {
      if (id == passenger.id){
        selectedpassenger = passenger;
        selectedpassenger.isActive = 1;
      }
    });
    this.http
      .put(
        '/api/passenger/' + id,
        { passenger: selectedpassenger }
      )
      .subscribe(
        result => {
          document.getElementById('passenger_' + id).remove();
        },
        error => {
          this.pnotify.error({
            title: 'Erreur',
            text: 'Une erreur est survenue !',
            stack: {
              firstpos1: 70, firstpos2: 10,
              modal: true,
              overlay_close: true
            },
            hide: false,
            modules: {
              Confirm: {
                confirm: true,
                buttons: [
                  {
                    text: 'Ok',
                    addClass: 'btn btn-chico',
                    click: notice => {
                      notice.close();
                    }
                  }
                ]
              }
            }
          });
        }
      );
  }

  onBulkActive() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous activer la selection ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                $('[name="checkboxs[]"]:checked').each((i, elt: any) => {
                  this.active($(elt).val());
                });
                this.selectedMulti = false;
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  onBulkDelete() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer la selection ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                $('[name="checkboxs[]"]:checked').each((i, elt: any) => {
                  this.delete($(elt).val());
                });
                this.selectedMulti = false;
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  delete(id) {
    this.http
      .delete('/api/passenger/' + id)
      .subscribe(
        result => {
          document.getElementById('passenger_' + id).remove();
        },
        error => {
          this.pnotify.error({
            title: 'Erreur',
            text: 'Une erreur est survenue !',
            stack: {
              firstpos1: 70, firstpos2: 10,
              modal: true,
              overlay_close: true
            },
            hide: false,
            modules: {
              Confirm: {
                confirm: true,
                buttons: [
                  {
                    text: 'Ok',
                    addClass: 'btn btn-chico',
                    click: notice => {
                      notice.close();
                    }
                  }
                ]
              }
            }
          });
        }
      );
  }

  onFilter(): void {
    this.staticFilter = this.filter;
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
       dtInstance.draw();
    });
  }

  onExport() {
    this.http.post(
      '/api/passenger',
      { filter: this.staticFilter }
    ).subscribe((resp: any) => {
      const stopOrder = [
        [
          'vehicle-id',
          'stop-id',
        ]
      ];

      const stops = [
        [
          'id',
          'job-id',
          'type',
          'name',
          'address',
          'latitude',
          'longitude',
          'service-duration',
          'start-time',
          'end-time',
          'quantity',
        ]
      ];
      for (let i = 0; i < resp.data.length; i++) {
        stops.push([
          'ID' + resp.data[i].id,
          '',
          'P',
          resp.data[i].lastname + ' ' + resp.data[i].firstnames,
          resp.data[i].phone,
          resp.data[i].lat,
          resp.data[i].lng,
          '00:00:45',
          resp.data[i].estimatedDepartureTime,
          resp.data[i].estimatedArrivalTime,
          resp.data[i].count,
        ]);
      }
      const vehicleTypes = [
        [
          'vehicle-name',
          'vehicle-id',
          'start-latitude',
          'start-longitude',
          'end-latitude',
          'end-longitude',
          'start-time',
          'end-time',
          'capacity',
          'number-of-vehicles',

        ]
      ];
      const arrBusIds = [];
      for (let i = 0; i < resp.data.length; i++) {
        if (resp.data[i].hasOwnProperty('Bus')) {
          if (!arrBusIds.includes(resp.data[i].Bus.id)) {
            vehicleTypes.push([
              resp.data[i].Bus.name,
              resp.data[i].Bus.id,
              resp.data[i].School.lat,
              resp.data[i].School.lng,
              resp.data[i].School.lat,
              resp.data[i].School.lng,
              '',
              '',
              resp.data[i].Bus.maxLoad,
              '1',
            ]);
            arrBusIds.push(resp.data[i].Bus.id);
          }
        }
      }

      this.excelService.exportAsExcelFileWithMultiplePage([
        {
          name: 'Stop-order',
          data: stopOrder
        },
        {
          name: 'Stop',
          data: stops
        },
        {
          name: 'VehiculeTypes',
          data: vehicleTypes
        }], 'Rapport');
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/passenger/passenger-archive/passenger-archive.component.ts